import { useEffect, useRef, useState } from "react";
import { Field, ErrorMessage, Formik } from "formik";
import TextError from "components/form/textError";
import {
  Container,
  Element,
  Icon,
  IconContainer,
  LabelContainer,
} from "./index.styled";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
export default function Input({
  name,
  type,
  placeholder,
  label,
  leftIcon = false,
  rightIcon = false,
  toggleType = false,
  width,
  height = "48px",
  borderColor = "#E9EBF8",
  fontColor = "#0f0f0f",
  placeholderColor = "#27548c",
  minHeight = "76px",
  width417,
  width360,
  height1024 = "48px",
  defaultValue,
  active = true,
}) {
  const inputElement = useRef();
  const [errorMode, setErrorMode] = useState(false);
  const [inputType, setInputType] = useState(type);

  useEffect(() => {
    if (errorMode) {
      inputElement.current.style.border = "1px solid #FF3D3D";
    } else {
      inputElement.current.style.border = `1px solid ${borderColor}`;
    }
  }, [errorMode]);

  const handleToggleType = () => {
    if (inputType === "password") {
      setInputType("text");
    } else {
      setInputType("password");
    }
  };

  return (
    <Field name={name}>
      {({ field, meta }) => (
        <div style={{ minHeight: minHeight, direction: "rtl" }}>
          <LabelContainer>
            <label>{label}</label>
          </LabelContainer>
          <Container
            ref={inputElement}
            width={width}
            height={height}
            className={!active && "disabled"}
            width360={width360}
            width417={width417}
            height1024="48px"
          >
            {rightIcon && (
              <IconContainer rightIcon>
                <Icon src={rightIcon} />
              </IconContainer>
            )}
            <Element
              leftIcon
              rightIcon
              type={inputType}
              placeholder={placeholder}
              {...field}
              fontColor={fontColor}
              placeholderColor={placeholderColor}
              background="transparent"
              enableReinitialize={true}
              className={!active && "disabled"}
              disabled={!active && true}
              value={defaultValue}
              defaultValue={defaultValue}
            />
            {leftIcon && (
              <IconContainer
                leftIcon
                toggleType={toggleType}
                onClick={handleToggleType}
              >
                {inputType === "text" ? (
                  <AiOutlineEye />
                ) : (
                  <AiOutlineEyeInvisible />
                )}
              </IconContainer>
            )}
          </Container>
          <ErrorMessage component={TextError} name={name} />
          {meta.touched && meta.error
            ? setErrorMode(true)
            : setErrorMode(false)}
        </div>
      )}
    </Field>
  );
}
